// @flow
export const PAYMENT_STATUS_UNPAID: 'unpaid' = 'unpaid';
export const PAYMENT_STATUS_PAID: 'paid' = 'paid';
export const PAYMENT_STATUS_CANCELED: 'canceled' = 'canceled'; // deprecated
export const PAYMENT_STATUS_REFUNDED: 'refunded' = 'refunded';
export const PAYMENT_STATUS_UNKNOWN: null = null;
